import _asyncToGenerator from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import VueRouterPrefetch from 'vue-router-prefetch';

// NavigationDuplicated 대응
var originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
var originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(function (err) {
    return err;
  });
};
Vue.use(VueRouter);
Vue.use(VueRouterPrefetch);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default function
  /* { store, ssrContext } */
() {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var routes, DetailArr, Router;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return process.env.BUILD_TARGET === 'pc' ? import('src/pc/router/routes') : import('src/mobile/router/routes');
        case 2:
          routes = _context.sent.default;
          // const Router = new VueRouter({
          //   scrollBehavior: () => ({ x: 0, y: 0 }),
          //   routes,
          //
          //   // Leave these as is and change from quasar.conf.js instead!
          //   // quasar.conf.js -> build -> vueRouterMode
          //   // quasar.conf.js -> build -> publicPath
          //   mode: process.env.VUE_ROUTER_MODE,
          //   base: process.env.VUE_ROUTER_BASE
          // })
          DetailArr = ['ArticleDetail'];
          Router = new VueRouter({
            // linkActiveClass: 'active',
            scrollBehavior: function scrollBehavior(to, from, savedPosition) {
              if (savedPosition) {
                return savedPosition;
              } else if (to.hash) {
                return {
                  selector: to.hash
                };
              } else if (to.name === from.name) {
                if (DetailArr.includes(to.name)) return {
                  x: 0,
                  y: 0
                };
                return false;
              } else {
                return {
                  x: 0,
                  y: 0
                };
              }
            },
            routes: routes,
            // short for routes: routes
            mode: process.env.VUE_ROUTER_MODE,
            base: process.env.VUE_ROUTER_BASE,
            hash: false
          });
          return _context.abrupt("return", Router);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ref.apply(this, arguments);
}